import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import Files from 'react-files'

export default class ExtractFiles extends Component {
  constructor(props) {
		super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onFilesChange = this.onFilesChange.bind(this);
    this.removeFiles = this.removeFiles.bind(this);
    this.state = {
      text: "",
      csv: "",
      files: []
      };
  }

  onFilesChange(files) {
    var that = this;
    var reader = new FileReader();
      reader.onload = function(evt) {
        that.setState({text: evt.target.result})
      };
    reader.readAsText(files[0]);

  }

  onFilesError(error, files) {
    console.log(files)
  }

  handleClick(){
    var csv = ""
    var text = this.state.text.split("\n")
    for (var i = 0; i < text.length ; i++){
      var thisLine = text[i].split(",")
      var id = thisLine[0]
      var grados = parseFloat(thisLine[1])
      var minutos = parseFloat(thisLine[2])
      var segundos = parseFloat(thisLine[3])
      var altura = parseFloat(thisLine[4])
      var densidad = parseFloat(thisLine[5])
      var radio = parseFloat(thisLine[6])
      var gravedadObservada = parseFloat(thisLine[7])

      var decimal = ((grados + (minutos + segundos/60))/60)
      var radianes = (decimal * Math.PI)/180
      var gravedadTeorica = (-978.032681*(1+0.0052789704*Math.pow(Math.sin(radianes), 2))) + 0.0000234611*(Math.pow(Math.sin(radianes)), 4)
      var anomaliaGravedad = gravedadObservada - gravedadTeorica
      var correccionAire = -0.3086 * altura
      var anomaliaAire = gravedadObservada - gravedadTeorica + correccionAire
      var correccionBSimple = 1.119 * altura
      var anomaliaBsimple = gravedadObservada - gravedadTeorica + correccionAire - correccionBSimple
      var correccionTopografica = 1.119 * radio
      var anomaliaBTotal = gravedadObservada - gravedadTeorica + correccionAire - correccionBSimple - correccionTopografica
      csv += id + "," + gravedadTeorica + "," + anomaliaGravedad + "," + correccionAire + "," + anomaliaAire + "," + correccionBSimple + "," + anomaliaBsimple + "," + correccionTopografica + "," + anomaliaBTotal + "\n"
  }
  const element = document.createElement("a");
  const file = new Blob([csv], {type: 'text/plain'});
  element.href = URL.createObjectURL(file);
  element.download = "report.csv";
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
}


  removeFiles(){
    this.refs.files.removeFiles()
  }


  render() {
    return (
      <div className="files">
        <Files
          onClick={this.removeFiles}
          ref = 'files'
          className='files-dropzone'
          onChange={this.onFilesChange}
          onError={this.onFilesError}
          accepts={[
            'text/csv',
            'text/plain',
            'application/csv',
            'text/comma-separated-values',
            'application/excel',
            'application/vnd.ms-excel',
            'application/vnd.msexcel',
            'text/anytext',
            'application/octet-stream',
            'application/txt']}
          maxFiles={1}
          maxFileSize={10000000}
          minFileSize={0}
        >
          <h3> <p>Arrastre su archivo en formato .csv o .txt o haga <u>clic aquí</u> para cargar archivo</p></h3>
          <h5><p> El orden de las columnas del archivo debe ser así:</p></h5>
          <p> ID, Grados(°), Minutos('), Segundos("), Altura (msnm), Densidad, Radio utilizado (m), Gravedad Observada </p>
          <h5><p> Una vez cargado el archivo, presione el botón para generar el reporte </p>  </h5>
<p> </p>
<p></p>
<p></p>
<i>  Desarrollado por Michelle Nohelia Niño Ortiz  y Nicolás Cubillos Valderrama </i>
<p><i>  Para la Universidad  Distrital Francisco José de Caldas</i></p>

        </Files>
        <button type="button" onClick={this.handleClick}>Generar reporte</button>

      </div>
    )
	}

}
